import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { TextoTermosContratacao } from "./texto-termos-contratacao-tag.model";

@Injectable({
    providedIn: 'root'
})
export class TextoTermosService extends FgiBackEndService<TextoTermosContratacao>{

    termosContratacao$ = this.getTermosContratacao().pipe(map(resp => resp.termosContratacao));

    termosEnvioDevolucaoHonra$ = this.getTermosContratacao().pipe(map(resp => resp.termosEnvioDevolucaoHonra));
    
    termosInformeLiquidacaoOperacao$ = this.getTermosContratacao().pipe(map(resp => resp.termosInformeLiquidacaoOperacao));
 
    getNewEntity(): TextoTermosContratacao {
        const model = new TextoTermosContratacao();
        return model;
    }    

    protected getResourceURL(): string {
      return undefined;
    }

    getTermosContratacao() {
      return this.http.get('rest/front/parametrosNegocio').pipe(
        catchError((e) => this.handleError(e))) as Observable<TextoTermosContratacao>;
  }

}